<template>
  <Layout>
    <div class="section  content is-size-7 has-text-white">
      <p class="is-size-5 has-text-primary">{{ $t('Deactivation') }}</p>
      <p>
        Pretplata se obnavlja automatski. Da biste se odjavili pošaljite poruku sadržaja STOP SKINI  na 06202020 (BH Telecom), 063770100 (HT Eronet) ili 0651388 (m:tel).
      </p>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/GG'

export default {
  name: 'Deactivation',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangGG/BA/Deactivation.vue